<template>
	<view class="m-switch">
		<view v-if="label" class="switch-label">{{ label }}</view>
		<switch :checked="checked" :color="color || undefined" :style="{ transform: 'scale(' + scale + ')' }" @change="onChange" />
	</view>
</template>

<script setup>
	const props = defineProps({
		checked: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		color: {
			type: String,
			default: ''
		},
		scale: {
			type: Number,
			default: 0.7
		}
	})
	const emit = defineEmits(['change'])

	function onChange(e) {
		emit('change', e)
	}
</script>

<style scoped>
	.m-switch {
		display: inline-flex;
		align-items: center;
		line-height: 1;
		transform-origin: center;
	}
	
	.switch-label {
		margin-left: auto;
		font-size: 28rpx;
		line-height: 28rpx;
		color: var(--text-secondary);
		cursor: pointer;
		padding: 0 5rpx;
	}
</style>